/**
 * 把方案管理的資料庫方案，轉成快速估價用的方案清單。
 * 月費、名稱、用量上限以資料庫為準；建置費與企業版好友級距仍沿用價目表。
 */

const CATALOG_CODE_BY_DB = {
  BASIC: 'basic',
  STANDARD: 'standard',
  PRO: 'professional',
  ENTERPRISE: 'enterprise'
};

const QUOTE_PLAN_ORDER = ['basic', 'standard', 'professional', 'enterprise'];

function numberOrNull(value) {
  if (value == null || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export function quoteCodeForPlan(planCode) {
  const code = String(planCode || '');
  return CATALOG_CODE_BY_DB[code] || code.toLowerCase();
}

/** 試用與測試方案不進報價清單 */
export function isQuotePlan(dbPlan) {
  if (!dbPlan || dbPlan.status !== 'active') return false;
  if (dbPlan.planType === 'trial') return false;
  const code = String(dbPlan.planCode || '');
  if (/^TEST/i.test(code)) return false;
  return true;
}

export function mapDbPlanToQuotePlan(dbPlan, catalogPlans = []) {
  const code = quoteCodeForPlan(dbPlan.planCode);
  const extras = catalogPlans.find((plan) => plan.code === code) || {};
  const monthlyPrice = code === 'enterprise'
    ? (extras.monthlyPrice ?? null)
    : numberOrNull(dbPlan.monthlyPrice);

  const mapped = {
    ...extras,
    code,
    dbPlanCode: dbPlan.planCode,
    name: dbPlan.planName,
    monthlyPrice,
    maxFriends: numberOrNull(dbPlan.maxMembers),
    limits: {
      stores: numberOrNull(dbPlan.maxStores),
      staffAccounts: numberOrNull(dbPlan.maxStaffAccounts),
      lineOa: numberOrNull(dbPlan.maxLineConfigs),
      api: Boolean(dbPlan.allowApiAccess),
      pos: Boolean(dbPlan.allowPosIntegration)
    }
  };

  if (code === 'wixtar_enterprise') {
    mapped.setupFee = 10000;
    mapped.setupFeeLabel = 'Wixtar企業版建置費';
  }

  return mapped;
}

export function mergeQuotePlans(baseCatalog, dbPlans) {
  const catalogPlans = baseCatalog?.plans || [];
  const mapped = (dbPlans || [])
    .filter(isQuotePlan)
    .map((plan) => mapDbPlanToQuotePlan(plan, catalogPlans));

  mapped.sort((a, b) => {
    const ai = QUOTE_PLAN_ORDER.indexOf(a.code);
    const bi = QUOTE_PLAN_ORDER.indexOf(b.code);
    if (ai !== -1 || bi !== -1) {
      if (ai === -1) return 1;
      if (bi === -1) return -1;
      return ai - bi;
    }
    return String(a.name || '').localeCompare(String(b.name || ''), 'zh-Hant');
  });

  return mapped;
}
